import React from 'react';
import { ActivityIndicator } from 'react-native';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import PageMeta from 'src/components/10-atoms/seo/PageMeta';
import { useListViewModeNavbarAction } from 'src/components/20-helper-views/ListViewModeToggle';
import Page from 'src/components/templates/page/Page.template';
import PageBody from 'src/components/templates/page/PageBody.template';
import PageHeader from 'src/components/templates/page/PageHeader.template';
import PageNavbar from 'src/components/templates/page/PageNavbar.template';
import { PageContentWidth } from 'src/constants/dimensions';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import useListViewMode, { isQuestionListMasterDetail } from 'src/hooks/useListViewMode';
import usePlaylistIntro from 'src/lib/playlist/hooks/usePlaylistIntro';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import EPBreadCrumbs from '../../components/EPBreadCrumbs';
import QuestionList from '../../containers/QuestionList';
import { NodeType } from '../../graphql/common/types/node';
import TopicNotesBanner from './components/TopicNotesBanner';
import { pageAnalytics } from './analytics';
import useData from './useData';
const TopicQuestions = ({ navigation, route }) => {
    const { topic, questionID } = route.params;
    const [{ deviceType }] = useTheme();
    const { translate } = useI18n();
    const { listViewMode } = useListViewMode();
    const listViewModeNavbarAction = useListViewModeNavbarAction();
    const isMasterDetail = isQuestionListMasterDetail(deviceType.isDesktop, listViewMode);
    const [state, actions] = useData();
    const { trigger: triggerPlaylistIntro } = usePlaylistIntro({
        onConfirm() {
            pageAnalytics.setWidget('TTS_Intro').setTarget('Get_Started').click();
        },
    });
    const handleSpeakPress = useStableCallback(async () => {
        await triggerPlaylistIntro();
        actions.playlist.play();
    });
    const handleSelectedQuestionIDChange = useStableCallback((nextQuestionID) => {
        navigation.setParams({ questionID: nextQuestionID });
    });
    return (React.createElement(Page, { layout: isMasterDetail
            ? { contentMaxWidth: PageContentWidth.MASTER_DETAIL }
            : undefined },
        React.createElement(PageMeta, { title: `${state.examLevel?.data.title ? state.examLevel.data.title + ' / ' : ''}${state.subject?.data.title ? state.subject.data.title + ' / ' : ''}${state.topic} — COC Exam Questions`, description: `Practice COC exam questions on the topic: ${state.topic}.`, noIndex: true }),
        React.createElement(PageHeader, null,
            React.createElement(PageNavbar, { backType: "back", title: translate('Topic-wise Questions'), onBackPress: navigation.goBack, actions: [
                    listViewModeNavbarAction,
                    state.subject?.type === NodeType.WRITTEN_SUBJECT && {
                        Icon(props) {
                            return state.playlist.playlistQuery.loading ? (React.createElement(ActivityIndicator, { size: "small" })) : (React.createElement(FeatherIcon, { name: "play-circle", ...props }));
                        },
                        title: 'Speak',
                        onPress() {
                            pageAnalytics.setWidget('Navbar').setTarget('TTS_Play').click();
                            handleSpeakPress();
                        },
                    },
                ] }),
            React.createElement(EPBreadCrumbs, { loading: state.subjectDetailsQuery.loading, knownNodes: {
                    examLevel: state.examLevel,
                    subject: state.subject,
                    topic: state.topic,
                }, visibleCount: 2 })),
        React.createElement(PageBody, null,
            React.createElement(QuestionList, { selectedQuestionID: questionID, onSelectedQuestionIDChange: handleSelectedQuestionIDChange, ListHeaderComponent: () => (React.createElement(TopicNotesBanner, { loading: state.notesQuery.loading, notes: state.notesQuery.data?.ep_notesForSubject })), style: styleUtils.containerHeight, variant: "topic-details", containerStyle: styleUtils.flex, queryState: state.listQuery, queryActions: actions.listQuery, variables: state.listQueryVariables, onQuestionPress: actions.trackQuestionPress, getQuestionTo: actions.getQuestionDetailsTo }))));
};
export default TopicQuestions;
